module.exports = __webpack_public_path__ + "static/media/logoCompany.c4628f8d.svg";